export type RemovablePreferenceValues = {
  completeBase: string | null;
  completeTeethShade: string | null;
  completeReinforcement: string;
  completeTeeth: string;
  completePeripheralSeal: string;
  partialFramework: string | null;
  partialAttachment: string | null;
  partialClasps: string;
  partialMetalFramework: string;
  protocol: string;
  customTrayWithWax: string;
  splintType: string | null;
  splintThickness: string | null;
  splintHardness: string;
  splintCoverage: string;
};

export const getRemovablePreferenceDefaults =
  (): RemovablePreferenceValues => ({
    completeBase: null,
    completeTeethShade: null,
    completeReinforcement: "",
    completeTeeth: "",
    completePeripheralSeal: "",
    partialFramework: null,
    partialAttachment: null,
    partialClasps: "",
    partialMetalFramework: "",
    protocol: "",
    customTrayWithWax: "",
    splintType: null,
    splintThickness: null,
    splintHardness: "",
    splintCoverage: "",
  });
